import { Trophy } from "lucide-react";

import { assetUrl } from "../../lib/tournamentApi";

export const GOLD = "#D4A93C";

export function BrandLogo({ branding, size = 56, testId = "brand-logo" }) {
  const url = assetUrl(branding?.logo_url);
  if (!url) return null;
  return <img src={url} alt="Tournament logo" data-testid={testId}
              style={{ height: size, width: "auto", maxWidth: size * 2.4, objectFit: "contain", flexShrink: 0 }} />;
}

export function SponsorStrip({ branding, tile = 64, testId = "sponsor-strip", label = true }) {
  const sponsors = branding?.sponsors || [];
  if (!sponsors.length) return null;
  return (
    <div data-testid={testId}>
      {label && <div style={{ fontSize: 10, letterSpacing: "0.14em", textTransform: "uppercase", opacity: 0.6, marginBottom: 8 }}>Thank you to our sponsors</div>}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
        {sponsors.map((s) => {
          const img = (
            <div style={{ height: tile, width: tile * 2, background: "#F5F0E8", borderRadius: 10, display: "grid", placeItems: "center", padding: 6 }}>
              <img src={assetUrl(s.logo_url)} alt={s.name} style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }} />
            </div>
          );
          return s.url
            ? <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer sponsored" data-testid={`sponsor-${s.id}`} title={s.name}>{img}</a>
            : <div key={s.id} data-testid={`sponsor-${s.id}`} title={s.name}>{img}</div>;
        })}
      </div>
    </div>
  );
}

/** Champion block for one division's results (placements carry team names only). */
export function ChampionCard({ result, scale = 1, testId }) {
  const champ = result.placements.find((p) => p.key === "champion");
  const rest = result.placements.filter((p) => p.key !== "champion");
  return (
    <div data-testid={testId} style={{ background: "rgba(245,240,232,0.06)", border: "0.5px solid rgba(245,240,232,0.16)",
                                       borderRadius: 16 * scale, padding: 20 * scale, animation: "pt-fade 400ms ease both" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
        <div style={{ fontSize: 12 * scale, letterSpacing: "0.14em", textTransform: "uppercase", opacity: 0.7 }}>{result.name}</div>
        <div style={{ fontSize: 11 * scale, fontWeight: 800, color: result.complete ? "#4db87a" : "#B9B4A8", letterSpacing: "0.1em" }}>
          {result.complete ? "FINAL" : "IN PROGRESS"}</div>
      </div>
      <div style={{ display: "flex", gap: 10 * scale, alignItems: "center", marginTop: 12 * scale }}>
        <Trophy size={28 * scale} color={GOLD} aria-hidden="true" style={{ flexShrink: 0 }} />
        <div>
          <div style={{ color: GOLD, fontWeight: 800, fontSize: 12 * scale, letterSpacing: "0.14em" }}>CHAMPION</div>
          <div data-testid={testId && `${testId}-champion`}
               style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 44 * scale, lineHeight: 1, letterSpacing: "0.02em" }}>
            {champ?.name || "To be decided"}</div>
        </div>
      </div>
      {rest.length > 0 && (
        <div style={{ display: "grid", gridTemplateColumns: `repeat(auto-fill, minmax(${180 * scale}px, 1fr))`, gap: 10 * scale, marginTop: 16 * scale }}>
          {rest.map((p) => (
            <div key={p.key} data-testid={testId && `${testId}-${p.key}`}>
              <div style={{ fontSize: 10 * scale, letterSpacing: "0.12em", textTransform: "uppercase", color: "#4db87a", fontWeight: 800 }}>{p.label}</div>
              <div style={{ fontSize: 17 * scale, fontWeight: 700 }}>{p.name || "TBD"}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
